// extracted by mini-css-extract-plugin
export var borderRadius = "_aj-4";
export var large = "_aj-3";
export var logoContainer = "_aj-0";
export var nameLogo = "_aj-2";
export var small = "_aj-1";